<template>
  <bsp-dialog title="提交前提醒" :dialogVisible.sync="visible" top="15vh" @closeButton="closeDialog" >
    <template #body v-loading="loading">
      <div v-show="okType == '1'">
        <el-row>
          <el-col inline :span="24">
            <span style="color: red;">{{errMsg1}}</span>
          </el-col>
        </el-row>
      </div>
      <div v-show="okType != '1'">
        <el-row v-show="yl == 'false'">
          <el-col inline :span="24">
            <span style="color: red;">{{$t('cost.cost098')}}</span><!-- 医疗项目，请单独申报 -->
          </el-col>
        </el-row>

        <el-row class="costDetailRow" v-show="costProcessList != null && costProcessList.length > 0">
          <el-col class="costDetailHeader" inline :span="24" style="background-color: #F47378;">
            <span style="font-weight: bold;color: #f1f1f1">{{$t('cost.cost099')}}</span><!-- 申请提交后将正式进入审批，审批流程如下 -->
          </el-col>
        </el-row>
        <el-row class="costDetailRow" v-for="(costProcess,index) in costProcessList" :key="index">
          <el-col class="costDetailCol" inline :span="2" >
            <span style="">{{index+1}}</span>
          </el-col>
          <el-col class="costDetailCol" inline :span="22" style="text-align: left; padding-left: 10px;">
            <span style="">{{costProcess.roleName}}</span>
          </el-col>
        </el-row>
        <el-row class="costDetailRow" v-show="costProcessList == null || costProcessList.length ==0" >
          <el-col class="costDetailCol" inline :span="24">
            <span style="color: red;">{{$t('cost.cost100')}}</span><!-- 当前报销没有匹配到符合条件的报销流程，不能提交 -->
          </el-col>
        </el-row>


        <el-row class="costDetailRow" v-show="budgetWarnList != null && budgetWarnList.length > 0">
          <el-col class="costDetailHeader" inline :span="24" style="background-color: #F47378;">
            <span style="font-weight: bold;color: #f1f1f1">{{$t('cost.cost101')}}</span><!-- 预算情况 -->
          </el-col>
        </el-row>
        <el-row class="costDetailRow" v-for="(budgetWarn,index) in budgetWarnList" :key="index">
          <el-col class="costDetailCol" inline :span="5" v-show="budgetWarn.dug == 'new'" >
            <span style="">{{budgetWarn.eyed}}</span>
          </el-col>
          <el-col class="costDetailCol" inline :span="5" >
            <span style="">{{budgetWarn.projectName}}</span>
          </el-col>
          <el-col class="costDetailCol" inline :span="5" >
            <span style="">{{budgetWarn.codeItemName}}</span>
          </el-col>
          <el-col class="costDetailCol" inline :span="5" >
            <span style="">{{budgetWarn.quotaName}}</span>
          </el-col>
          <el-col class="costDetailCol" inline :span="5" v-show="budgetWarn.dug == 'true'">
            <span style="">{{budgetWarn.money}}</span>
          </el-col>
          <el-col class="costDetailCol" inline :span="4" >
            <span style="">{{budgetWarn.quota}}</span>
          </el-col>
        </el-row>
      </div>
    </template>
    <div class="dialog-footer" slot="footer">
      <el-button @click="closeDialog">{{$t('cost.cost079')}}</el-button><!-- 取 消 -->
      <el-button type="primary" v-if="okType != '1' && flag == 'true' && costProcessList != null && costProcessList.length > 0" @click="submit">{{$t('cost.cost078')}}</el-button><!-- 确  定 -->
    </div>
  </bsp-dialog>
</template>

<script>

import BspDialog from "@/components/bsp/bsp-dialog/bsp-dialog";
import {mapGetters} from 'vuex';

export default {
  name: "preViewCostProcess",
  components: { BspDialog },
  props:{
    optParams: {
      type: Object,
      default: function (){
        return {
        };
      },
    },
  },
  data() {
    return {
      searchForm:{},
      searchParams: {},
      demoLoading: true,
      loadingImport: false,
      loadingBtn: false,
      visible: false,
      okType: '',
      flag: '',
      errMsg1 : '',
      yl: '',
      budgetWarnList: [],
      costProcessList: [],
      dataList: [],
    };
  },
  created() {

  },
  mounted(){
    // console.log("批次号m",this.billBatch)
  },
  methods: {

    // 查询
    handleSearch() {
      this.searchParams = this.searchForm;
    },
    handleReset() {
      this.searchForm = {};
      this.searchParams = this.searchForm;
    },


    init() {
      console.log("preViewCostProcess" , this.optParams);
      this.okType = this.optParams.okType;
      this.flag = this.optParams.flag;
      if(this.okType == '1'){
        this.errMsg1 = this.optParams.projectName;
      }else{
        this.budgetWarnList = this.optParams.budgetWarnList;
        this.costProcessList = this.optParams.costProcessList;
        this.dataList = this.optParams.dataList;
      }
    },

    submit(){
      this.$emit('reload');
      this.clearForm();
      this.visible = false;
    },

    closeDialog () {
      this.visible = false;
      // const that = this;
      // this.$confirm(
      //   '是否放弃当前操作！',
      //   '提示',
      //   {
      //     type: 'warning'
      //   }
      // ).then(function(){
      //   //确认操作
      //   that.clearForm();
      //   that.visible = false;
      // }).then((data) => {
      //   //取消操作
      // }).catch(function (err) {
      //   //捕获异常
      // });

    },
    close (){
      this.clearForm();
      this.visible = false;
    },
    clearForm(){
      this.$set(this.searchForm, "startDate", "");
      this.$set(this.searchForm, "endDate", "");
    },


    isNotBlank(str){
      if(str == null || str ==undefined || str == ''){
        return false;
      }else{
        return true;
      }
    }
  },
  destroyed(){
  },
  computed: {
    ...mapGetters(['billBatch','userInfo','dicts']),

  }
};
</script>

<style lang="scss">
</style>
